import { Container } from "react-bootstrap";
import Footer from "./Footer";
import NavMenu from "./NavMenu";

export default function Layout(props: any) {
  return (
    <div className="page-container">
      <NavMenu />
      <Container fluid={true} className="pt-4">
        {props.children}
      </Container>
      <Footer />
    </div>
  );
}